/**
 * Sobáčov logo lockup — official red badge + Manrope wordmark.
 * Wordmark + tagline škálují podle parent fontSize — nastav font-size na
 * containeru (např. `text-xl md:text-2xl` v Header.tsx).
 */
export function Logo({
  className,
  variant = 'dark',
  showTagline = true,
}: {
  className?: string
  variant?: 'dark' | 'light'
  showTagline?: boolean
}) {
  const isLight = variant === 'light'
  // Barvy podle Základního logomanuálu (24. 10. 2026): nápis tmavě zelená #0F231D,
  // dovětek značková růžová #F41463; negativní verze na tmavém = bílá.
  const wordColor = isLight ? '#FFFFFF' : '#0F231D'
  const tagColor = isLight ? 'rgba(255,255,255,0.85)' : '#F41463'

  return (
    <div
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.55em' }}
      aria-label="Sobáčov"
    >
      <img
        src="/logo/sobacov_badge.svg?v=officialred4hook"
        alt=""
        aria-hidden="true"
        style={{ height: '100%', width: 'auto', flex: '0 0 auto', objectFit: 'contain' }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <div
          style={{
            fontFamily: "'Manrope','Inter',sans-serif",
            fontWeight: 700,
            fontSize: '1.4em',     // 1.4× parent fontSize
            letterSpacing: '0.03em',
            textTransform: 'uppercase',
            color: wordColor,
          }}
        >
          Sobáčov
        </div>
        {showTagline && (
          <div
            style={{
              marginTop: '0.5em',
              fontFamily: "'Manrope','Inter',sans-serif",
              fontWeight: 500,
              fontSize: '0.55em',   // 0.55× parent fontSize
              letterSpacing: '0.25em',
              textTransform: 'uppercase',
              color: tagColor,
              whiteSpace: 'nowrap',
            }}
          >
            Fishing &amp; Sport Resort
          </div>
        )}
      </div>
    </div>
  )
}
